<template>
    <div>
        <Breadcrumbs main="Summary" title="Summary Report">
            <div class="form-group">
                <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
            </div>
        </Breadcrumbs>
        <!-- <div class="form-group">
            <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
        </div> -->
        <div class="container-fluid">
            <div class="row ">
                <div v-if="userAdmin" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-cart" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Total Shops</span>
                          <h4 class="mb-0 counter">{{ shops }}</h4><feather type="shopping-cart" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-info static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Total {{ userAdmin ? 'Sign ups' : 'Customers' }}  </span>
                          <h4 class="mb-0 counter">{{ getCust.length }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="navigation" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Total Visits</span>
                          <h4 class="mb-0 counter">{{ getVisit.length }}</h4><feather type="navigation" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div v-if="!userAdmin" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-info static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Rated</span>
                          <h4 class="mb-0 counter"> {{ getRated }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="box" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Products</span>
                          <h4 class="mb-0 counter"> {{ getProducts.length }} </h4><feather type="box" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
            </div>
            <h4 class="m-2 mb-4"> Review Report</h4>
            <div class="row">
              <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="check-square" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Totol Reviews</span>
                          <h4 class="mb-0 counter"> {{ getReviews.length }} </h4><feather type="check-square" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-info static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="message-square" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Totol Suggestions</span>
                          <h4 class="mb-0 counter"> {{ getSugg.length }} </h4><feather type="message-square" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="send" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Most Visited </span>
                          <h4 class="mb-0 counter"> {{ getMostVisited ? getMostVisited.udata.name : 'None' }} </h4><feather type="send" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-info static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="thumbs-up" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Most Reviewed</span>
                          <h4 class="mb-0 counter">{{ getMostReviewed ? getMostReviewed.udata.name : 'None' }}</h4><feather type="thumbs-up" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
            </div>
            <h4 class="m-2 mb-4"> Preference Report</h4>
            <div class="row ">
                <div v-for="cat in getPrefs" :key="cat.cat" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="box" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> {{ cat.cat }} </span>
                          <h4 class="mb-0 counter">{{ (cat.value/users.length)*100+'%' }}</h4><feather type="box" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'VendorReport',
        data() {
            return {
                reportOptions: [
                                    { value: null, text: 'Select Report' },
                                    { value: 'T', text: 'Today' },
                                    { value: 'W', text: 'This Week' },
                                    { value: 'M', text: 'This Month' },
                                    { value: 'Y', text: 'This Year' },
                                    { value: 'PW', text: 'Previous Week' },
                                    { value: 'PM', text: 'Previous Month' },
                                    { value: 'PY', text: 'Previous Year' },
                            ],
                report: 'Y',
                items: [],
                users: 0,
                rated: 0,
                visits: 0,
                products: 0,
            }
        },
        computed: {
            userAdmin() {
            return localStorage.getItem('type') == "admin" ? true : false
            },
            getUser() {
            return this.$store.getters['authentication/getUser']
            },
            getCust(){
              return this.filter(this.users)
            },
            getVisit() {
              return this.filter(this.visits)
            },
            getReviews() {
              //
              let data = this.filter(this.visits).filter(v=> v.comment !== "")
              return data
            },
            getSugg() {
              let data = this.filter(this.visits).filter(v=> v.suggestion !== "")
              return data
            },
            getResponse() {
              let data = this.filter(this.visits).filter(v=> v.response !== "")
              return data
            },
            getMostVisited() {
              let data = this.mode(this.filter(this.visits).filter(v=> v.rate))
              return data
            },
            getMostReviewed() {
              let data = this.mode(this.filter(this.visits).filter(v=> v.comment !== ""))
              return  data
            },
            getRated() {
              let vd = this.filter(this.visits)
              let rateLen = vd.length
              console.log(vd.length)
              let rated = (((vd).reduce((a, b) => a + b.rate, 0)) / rateLen).toFixed(1)
              return rated ? rated : 0
            },
            getProducts() {
              return this.filter(this.products)
            },
            getPrefs() {

              const data = this.filter(this.users)

              let pref = []

              for (let index = 0; index < data.length; index++) {

                pref.push(data[index].preferences)
                                
              }

              let allpref = pref.flat()

              let array = []

              for (let index = 0; index < this.getUser.categories.length; index++) {
                //
                let c = 0;

                allpref.forEach(v=>v === this.getUser.categories[index] && c++)
                              
                array.push ({ cat: this.getUser.categories[index], value: c});

              }
                            
              array.sort(function(a, b) {
                return parseFloat(b.value) - parseFloat(a.value);
              });

              // this.pref = array

              return array

            },
            re() {
              return this.report;
            }
        },
        created() {
            // watch and fetch
            this.$watch(
            () => this.$route.$params,
            () => {
                this.fetchData()
            },
            { immediate: true }

            )

        },
        methods: {
          filter(data){
              //
              let value = ''
              
              switch (this.report) {
                case "Y":
                  
                  value = data

                  break;

                case "PY":

                  value = data.filter(d=>d.date.includes(moment().subtract(1, 'years').toDate().toISOString().substring(0,4)))

                break;

                case "T":

                  value = data.filter(d=>d.date.includes(new Date().toISOString().substring(0,10)))
                  
                break;

                case "YS":

                  value = data.filter(d=>d.date.includes(moment().subtract(1, 'days').toDate().toISOString().substring(0,10)))
                  
                break;


                case "M":

                  value = data.filter(d=>d.date.includes(new Date().toISOString().substring(0,7)))
                  
                break;


                case "PM":

                  value = data.filter(d=>d.date.includes(moment().subtract(1, 'month').toDate().toISOString().substring(0,7)))
                  
                break;

                case "W":

                  value = data.filter(d => this.getWeek().includes(d.date.substring(0,10)))
                  
                break;

                case "PW":

                  value = data.filter(d => this.getWeek(moment().subtract(1, 'week').toDate().toISOString().substring(0,10)).includes(d.date.substring(0,10)))
                  
                break;
              
                default:
                  break;
              }

              return value
            },
            fetchData() {

                const url = this.userAdmin ? '/users/' : '/users/'+this.getUser.name

                  axios.get(url)
                    .then(response=>{
                      //
                      this.users = response.data

                      for (let index = 0; index < this.users.length; index++) {

                          // date
                          if (this.users[index].createdAt) {
                            this.users[index].date = this.userAdmin ? (new Date(this.users[index].createdAt)).toISOString() : (new Date(this.users[index].shops.find(s=>s.shop == this.getUser.name).createdAt)).toISOString()
                          
                          }

                          const shop = this.users[index].shops.find(shop => shop.shop == this.getUser.name)

                          if (shop) {
                            this.users[index].preferences = shop.preferences
                          }
                          
                      }

                      

                    })
                    .catch( e => {
                      this.$swal({
                        title:"Failed!",
                        text:e.response.data,
                        type:'error'
                      });
                    })

                  axios.get('/Shop')
                    .then(response=>{
                      //
                      this.shops = response.data.length

                      for (let index = 0; index < this.shops.length; index++) {

                          // date
                          if (this.shops[index].createdAt) {
                            this.shops[index].date = (new Date(this.shops[index].createdAt)).toISOString()
                          
                          }
                          
                      }

                    })
                    .catch( e => {
                      this.$swal({
                        title:"Failed!",
                        text:e.response.data,
                        type:'error'
                      });
                    })

                    const url2 = this.userAdmin ? '/visit/' : '/visit/'+this.getUser.name

                    axios.get(url2)
                    .then(response=>{
                      //
                      this.visits = response.data

                      for (let index = 0; index < this.visits.length; index++) {

                          // date
                          if (this.visits[index].createdAt) {
                            this.visits[index].date = (new Date(this.visits[index].createdAt)).toISOString()
                          }
                          
                      }

                      // if (!this.userAdmin) {
                      //   for (let index = 0; index < this.visits.length; index++) {
                      //       // const element = array[index];
                      //       const rateLen = this.visits[index].rate.length

                      //       if (rateLen > 0) {
                      //       // sum rate
                      //       const rate = (this.visits[index].rate.reduce((a, b) => a + b, 0)) / rateLen
                      //       // to 2 decimalplaces
                      //       this.visits[index].rate = parseFloat(rate.toFixed(1))

                      //       // data.push(data[index])
                      //       } else {
                      //         this.visits[index].rate = 0
                      //       }
                      //   }
                      // }

                      // const rateLen = this.visits.length

                      //
                      // this.rated = ((response.data.reduce((a, b) => a + b.rate, 0)) / rateLen).toFixed(1)

                    })
                    .catch( e => {
                      this.$swal({
                        title:"Failed!",
                        text:e.response.data,
                        type:'error'
                      });
                    })

                    const url3 = this.userAdmin ? '/products/' : '/products/'+this.getUser.name

                    axios.get(url3)
                      .then(response=>{
                        //
                        this.products = response.data

                        for (let index = 0; index < this.products.length; index++) {

                            // date
                            if (this.products[index].createdAt) {
                              this.products[index].date = (new Date(this.products[index].createdAt)).toISOString()
                            }

                        }

                      })
                      .catch( e => {
                        this.$swal({
                          title:"Failed!",
                          text:e.response.data,
                          type:'error'
                        });
                      })
                },
                

            getReport() {
                console.log(this.report)
            },
            getWeek(date) {

              var curr = date ? new Date(date) : new Date(); // get current date
              var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
              // var last = first + 6; // last day is the first day + 6

              var firstday = new Date(curr.setDate(first)).toDateString().substring(4);
              // var lastday = new Date(curr.setDate(last)).toDateString().substring(4);

              let days =[]
              //
              for (let index = 0; index < 7; index++) {

                const d = moment(firstday).add(index, 'days').toDate().toISOString().substring(0,10)
                
                days.push(d)
              }

              // console.log(days)
              return days

            },
            mode(arr) {
                return arr.sort((a,b) =>
                    arr.filter(v => v.udata.name===a.udata.name).length
                    - arr.filter(v => v.udata.name===b.udata.name).length
                ).pop();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>